<template>
    <div class="msg-box">
      <!-- 列表显示 -->
      <component
        class="msg-box-in"
        v-if="config.showStyle == 'list'"
        :is="config.isScroll ? ElScrollbar : 'div'"
        :style="{
          height:
            typeof config.height == 'number' ? config.height + 'px' : 'auto',
        }"
      >
        <div v-for="(item, i) in articleList" :key="i" :class="{ 'new-box-item': true }">
          <el-image
            class="new-box-img-item"
            :style="{
              height:
                typeof config.imageHeight == 'number'
                  ? config.imageHeight + 'px'
                  : '92px',
              width:
                typeof config.imageWidth == 'number'
                  ? config.imageWidth + 'px'
                  : '55px',
            }"
                     referrerpolicy="no-referrer"
            :src="item.coverPic ? item.coverPic : ''"
          ></el-image>
  
          <div class="new-box-cont">
            <h6 class="new-box-cont-title">
              <NuxtLink :to="`/detail${isPc?'/pc':''}?detailId=${item.id}`"> {{ item.title }}</NuxtLink>
            </h6>
            <p class="new-box-cont-time">
              {{ item.createTime && item.createTime.split(" ")[0] }}
            </p>
          </div>
        </div>
      </component>
  
      <!-- 图片列表显示 -->
      <component
        v-if="config.showStyle == 'imageList'"
        :is="config.isScroll ? ElScrollbar : 'div'"
        :style="{
          height:
            typeof config.height == 'number' ? config.height + 'px' : 'auto',
        }"
      >
        <div class="new-image-wrap">
          <div
            v-for="(item, i) in articleList"
            :key="i"
            :class="{ 'new-image-item': true }"
          >
            <el-image
              class="new-image-pic"
              :title="item.title"
                       referrerpolicy="no-referrer"
              :previewSrcList="[item.coverPic ? item.coverPic : '']"
              :style="{
                height:
                  typeof config.imageHeight == 'number'
                    ? config.imageHeight + 'px'
                    : '92px',
                width:
                  typeof config.imageWidth == 'number'
                    ? config.imageWidth + 'px'
                    : '55px',
              }"
              :src="item.coverPic ? item.coverPic : ''"
            ></el-image>
          </div>
        </div>
      </component>
  
      <!-- 内容列表显示 -->
      <component
        v-if="config.showStyle == 'contentList'"
        :is="config.isScroll ? ElScrollbar : 'div'"
        :style="{
          height:
            typeof config.height == 'number' ? config.height + 'px' : 'auto',
        }"
      >
        <div
          v-for="(item, i) in articleList"
          :key="i"
          :class="{ 'new-detail-item': true }"
        >
          <NuxtLink
            v-if="!config.hiddenTitle"
            class="new-detail-item-title-link"
            :to="`/detail${isPc?'/pc':''}?detailId=${item.id}`"
          >
            <h6 class="new-detail-item-title">
              {{ item.title }}
            </h6>
          </NuxtLink>
          <div class="new-detail-item-cont" v-html="item.content"></div>
        </div>
      </component>
  
      <!-- 分页 -->
      <el-pagination
        v-if="config.isPagination"
        @size-change="handleCurrentChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo + 1"
        background
        :page-size="config.isShowArticleLength"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, watch, computed, onMounted, onBeforeUnmount } from 'vue';
  import { useRoute } from 'vue-router';
  import { getActiveListByTopicId, getActiveListFormPlatform } from "@/api";
  import { ElScrollbar } from "element-plus";
  
  // Props
  const props = defineProps({
    allArcListMap: {
      type: Object,
      default: () => ({}),
    },
    currentElementIndex: {
      type: Array,
      default: () => [],
    },
    idx: {
      type: Number,
      default: -1,
    },
    parentKeys: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
    },
  });
  
  // Variables
  const isPc = ref(useRoute().path.indexOf('v/m') < 0 && useRoute().path.indexOf('siteweb') < 0 && useRoute().path.indexOf('web') < 0);
  const pageNo = ref(0);
  const total = ref(props.allArcListMap[`${props.parentKeys.join(",")},${props.idx}`]?.totalRecord || 0);
  const list = ref(props.allArcListMap[`${props.parentKeys.join(",")},${props.idx}`]?.dataList || []);
  let lastId = null;
  
  // Watchers
  watch(() => props.config, (newConfig) => {
    if (newConfig.id !== lastId) {
      lastId = newConfig.id;
      window[`listFetchFunc_${newConfig.id}`] = fetchFunc;
      delete window[`listFetchFunc_${lastId}`];
    }
  }, { deep: true });
  
  // Computed Properties
  const currentElementIndexStr = computed(() => {
    return props.currentElementIndex.join("x");
  });
  
  const articleList = computed(() => {
    return list.value.map((item) => {
      if (item.type === 1 && item.content) {
        item.content = item.content.replace('video', 'video autoplay ');
      }
      return { ...item };
    });
  });
  
  // Methods
  const fetchFunc = async (fetchData) => {
    try {
      const response = await getActiveListFormPlatform({
        categoryId: props.config.categoryId,
        topicId: props.config.themeId,
        tagsValue: props.config.tagValue,
        pageNo: pageNo.value,
        pageSize: props.config.isShowArticleLength,
        ...fetchData,
      });
      list.value = response.data.dataList.map((o) => ({ ...o }));
      total.value = response.data.totalRecord || 0;
    } catch (e) {
      console.log(e);
    }
  };
  
  const handleCurrentChange = (data) => {
    pageNo.value = data - 1;
    fetchFunc();
  };
  
  const showDay = (item) => {
    let timeArr = item.updateTime ? item.updateTime.split(" ")[0].split("-") : [""];
    return timeArr[timeArr.length - 1];
  };
  
  const showMonth = (item) => {
    let timeArr = item.updateTime ? item.updateTime.split(" ")[0].split("-") : [""];
    return `${timeArr[0]}-${timeArr[1]}`;
  };
  
  // Mounted & Destroyed Lifecycle Hooks
  onMounted(() => {
    lastId = props.config.id;
    window[`listFetchFunc_${props.config.id}`] = fetchFunc;
  });
  
  onBeforeUnmount(() => {
    if (lastId) {
      delete window[`listFetchFunc_${props.config.id}`];
    }
  });
  </script>
  
  <style scoped>

  .msg-box-item {
    overflow: hidden;
    margin-bottom: 15px;
  }
  .msg-box-time-item {
    width: 56px;
    height: 56px;
    background: #f1f5f2;
    display: inline-block;
    text-align: center;
    margin: 0px 10px 0 0;
    vertical-align: middle;
  }
  .msg-box-time-item-top {
    font-size: 22px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 24px;
    margin-top: 7px;
    margin-bottom: 2px;
  }
  .msg-box-time-item-bottom {
    height: 14px;
    font-size: 12px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 14px;
  }
  .msg-box-cont {
    width: 159px;
    max-height: 60px;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    display: inline-block;
    vertical-align: middle;
  }
  .msg-box-cont-link {
    color: #666666;
    text-decoration: none;
  }
  .msg-box-cont-link:hover {
    color: #2a672d;
  }
  .msg-box :deep( .el-scrollbar__wrap) {
    overflow-x: hidden;
  }
  .new-box-item {
    overflow: hidden;
    margin-bottom: 12px;
    display: flex;
  }
  .new-box-item.active .new-box-img-item {
    border: 2px solid #2a672d;
  }
  .new-box-item.active .new-box-cont-title :deep(a) {
    color: #2a672d;
  }
  .new-box-item.active .new-box-cont-time {
    color: #2a672d;
  }
  .new-box-img-item {
    width: 91px;
    height: 55px;
    background: #f1f5f2;
    display: inline-block;
    text-align: center;
    margin: 0px 9px 0 0;
    vertical-align: middle;
  }
  .new-box-img-item-top {
    font-size: 22px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 24px;
    margin-top: 7px;
    margin-bottom: 2px;
  }
  .new-box-img-item-bottom {
    height: 14px;
    font-size: 12px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 14px;
  }
  .new-box-cont {
    flex: 1;
    max-height: 60px;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    display: inline-block;
    vertical-align: middle;
  }
  .new-box-cont-title {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 21px;
    max-height: 42px;
    overflow: hidden;
  }
  .new-box-cont-title :deep(a) {
    color: #666666;
    text-decoration: none;
  }
  .new-box-cont-time {
    height: 21px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
  }
  .new-image-wrap {
    display: flex;
  }
  .new-image-wrap .new-image-item {
    margin: 10px;
  }
  .new-detail-item {
    padding: 10px;
  }
  .new-detail-item .new-detail-item-title {
    font-size: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }
  .new-detail-item .new-detail-item-cont {
    font-size: 14px;
    padding: 0 0 10px;
  }
  .new-detail-item .new-detail-item-cont :deep(img) {
    display: block;
    max-width: 100%;
  }
  .new-detail-item-title-link {
    text-decoration: none;
    color: #000;
  }
  </style>
  